/* eslint-disable no-nested-ternary */
import React, { useState, useContext, useEffect } from 'react';
import { Button } from '@material-ui/core';
import { DialogBox } from '@mummssoftware/common-ui';
import { ProgressNotesContext } from '../Context/ProgressNotesContext';
import { Context } from '../../context';
import defaults from '../../translations/en.json';
import { DischargeMedsDiv } from '../../components/layout/WrapperDiv';

export const DischargeMedsModal = () => {
  const { resetRcopia, openRcopia } = useContext(Context);
  const { updateDisMaintainStatus } = useContext(ProgressNotesContext);

  const [open, setOpen] = useState<boolean>(false);

  const handleClick = () => {
    setOpen(false);
    resetRcopia();
  };

  useEffect(() => {
    if (openRcopia) {
      setOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openRcopia]);

  const openRcopiaModal = () => {
    updateDisMaintainStatus();
    resetRcopia();
  };

  return openRcopia ? (
    <DialogBox
      open={open}
      maxWidth="md"
      handleClick={handleClick}
      title="Medications at Discharge"
    >
      <DischargeMedsDiv>
        <p>{defaults.dischargeRcopia}</p>
        <Button
          title="OK"
          size="small"
          variant="contained"
          color="primary"
          onClick={openRcopiaModal}
        >
          {defaults.maintain}
        </Button>
      </DischargeMedsDiv>
    </DialogBox>
  ) : (
    <></>
  );
};
